import { createBrowserHistory } from 'history';
import { getPublicBasename } from '../utils/urls';
const history = createBrowserHistory({
  basename: getPublicBasename()
});
export function getHistory() {
  return history;
}